import { useState, ChangeEvent, FormEvent } from 'react';
import { Box, Button, Link, TextField, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import api from '../../services/axios-client';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [emailSent, setEmailSent] = useState(false);

  const handleInput = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    if (error) {
      setError('');
    }
  };

  const handleSubmit = async(e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!email) {
      setError('Email is required.');
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Please enter a valid email address.');
      return;
    }

    const data = { email };
    console.log(data);
    // Handle password reset logic here, for example:
    
    try{
      const result = await api.post(`${process.env.REACT_APP_API_URL}/forgot-password`, data);
      if(result.status === 200){
        setEmailSent(true);
      }
    }catch(error:any){
      if (error.response && error.status === 404) {
        setError(error.response.data.error);
      } else {
        setError('An error occurred. Please try again later.');
      }
    }
    
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
      }}
    >
      {!emailSent && <Box
        sx={{
          p: 4,
          maxWidth: 400,
          width: '100%',
          boxShadow: 3,
          borderRadius: 2,
        }}
      >
        <Typography component="h1" variant="h5" align="center" gutterBottom>
          Forgot Password?
        </Typography>
        <Typography variant="body2" align="center" sx={{ mb: 3 }}>
          Enter your email address and we'll send you a link to reset your password.
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={handleInput}
            error={!!error}
            helperText={error}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Send Reset Link
          </Button>
          <Box sx={{ textAlign: 'center' }}>
            <Link component={RouterLink} to="/login" variant="body2">
              Back to Login
            </Link>
          </Box>
        </Box>
      </Box>}

{/** Email Sent */}
      
{emailSent && <Box
        sx={{
          p: 4,
          maxWidth: 400,
          width: '100%',
          boxShadow: 3,
          borderRadius: 2,
        }}
      >
        <Typography component="h1" variant="h5" align="center" gutterBottom>
          Email Sent
        </Typography>
        <Typography variant="body2" align="center" sx={{ mb: 3 }}>
          Your password reset link sent on your email address. Please check your inbox.
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate>
          
          
          <Box sx={{ textAlign: 'center' }}>
            <Link component={RouterLink} to="/login" variant="body2">
              Back to Login
            </Link>
          </Box>
        </Box>
      </Box>}


    </Box>
  );
};

export default ForgotPassword;
